export const CUBSCLRBANRD="CUBSCLRBANRD"
export const CUBSCLRUPLDRD="CUBSCLRUPLDRD"
export const CUBSCLRUPLDWT="CUBSCLRUPLDWT"
export const DSLDASHRD="DSLDASHRD"
export const DSLDASHWT="DSLDASHWT"
export const DSLGEOUPLRD="DSLGEOUPLRD"
export const DSLGEOUPLWT="DSLGEOUPLWT"
export const DSLCRRD="DSLCRRD"
export const DSLCRWT="DSLCRWT"